import type { Icon } from '@phosphor-icons/react/dist/lib/types';
import { ChartPie as ChartPieIcon } from '@phosphor-icons/react/dist/ssr/ChartPie';
import { GearSix as GearSixIcon } from '@phosphor-icons/react/dist/ssr/GearSix';
import { PlugsConnected as PlugsConnectedIcon } from '@phosphor-icons/react/dist/ssr/PlugsConnected';
import { User as UserIcon } from '@phosphor-icons/react/dist/ssr/User';
import { Users as UsersIcon } from '@phosphor-icons/react/dist/ssr/Users';
import { XSquare } from '@phosphor-icons/react/dist/ssr/XSquare';
import { UserGear } from '@phosphor-icons/react/dist/ssr';
import { Exam } from '@phosphor-icons/react/dist/ssr';
import { Invoice } from '@phosphor-icons/react/dist/ssr';
import { Pulse } from '@phosphor-icons/react/dist/ssr';
import { ClipboardText } from '@phosphor-icons/react';
import { Headset } from '@phosphor-icons/react';
import { TreeStructure } from '@phosphor-icons/react';
import { CurrencyCircleDollar } from '@phosphor-icons/react';
import { Network } from '@phosphor-icons/react';
import { Browsers } from '@phosphor-icons/react';
export const navIcons = {
  'chart-pie': ChartPieIcon,
  'gear-six': GearSixIcon,
  'plugs-connected': PlugsConnectedIcon,
  'x-square': XSquare,
  agent: UserGear,
  company: Network,
  user: UserIcon,
  users: UsersIcon,
  assessment: Exam,
  program: Browsers,
  invoice: CurrencyCircleDollar,
  activity: Pulse,
  tasks: ClipboardText,
  workflow: TreeStructure,
  support: Headset,
  subscription: Invoice
} as Record<string, Icon>;
